<template>
  <div v-loading="loading">
    <el-dialog width="50%" :visible.sync="select_teacher_question_show" append-to-body align="center" :title="`${set_row.group_label}${set_row.question_label?set_row.question_label:''}-分配阅卷任务`">
      <TeacherSelectQuestion :question="set_row"></TeacherSelectQuestion>
    </el-dialog>
    <el-dialog width="50%" :visible.sync="select_teacher_exam_show" append-to-body align="center" :title="`按考试分配阅卷任务`">
      <TeacherSelectExam :exam_id="code"></TeacherSelectExam>
    </el-dialog>
    <el-alert title="不建议在已进行过阅卷的情况下再修改人员分配，尤其是退出分配，为保护数据，此类操作将被拒绝" type="error"></el-alert>
    <el-button-group>
      <el-button size="small" @click="set_teachers_exam" type="warning">全卷分配</el-button>
      <el-button size="small" @click="set_teachers_template" type="primary">模板分配</el-button>
      <el-button size="small" @click="download_teacher" type="info">全部导出</el-button>
    </el-button-group>
    <el-table :data="review_table" size="mini"
              border
              fit
    
              row-key="question_id"
              default-expand-all
              :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
              ref="review_table">
      <el-table-column
          prop="question_id"
          label="题块号">
      </el-table-column>
      <el-table-column
          prop="group_label"
          label="题块名称">
      </el-table-column>
      <el-table-column
          prop="question_label"
          label="小题名称">
      </el-table-column>
      <el-table-column
          prop="min_score"
          label="最小分">
      </el-table-column>
      <el-table-column
          prop="max_score"
          label="最高分">
      </el-table-column>
      <el-table-column
          label="可用打分项">
        <template slot-scope="scope">
          <template v-if="!isNaN(parseFloat(scope.row.question_index))">
            <el-input v-model="scope.row.scores" size="mini" @change="set_scores(scope.row)"></el-input>
          </template>
        </template>
      </el-table-column>
      <el-table-column
          label="评分策略" width="250">
        <template slot-scope="scope">
          <template v-if="isNaN(parseFloat(scope.row.question_index))||scope.row.mode==='s'">
            <el-select v-model="scope.row.police" placeholder="请选择" style="width: 80px" size="mini"
                       @change="need_save(scope.row)">
              <el-option
                  label="单评"
                  value="s">
              </el-option>
              <el-option
                  label="多评"
                  value="m">
              </el-option>
            </el-select>
            <template v-if="scope.row.police==='m'">
              阈值
              <el-input-number v-model="scope.row.police_val" :precision="1" :step="0.1"
                               style="width: 100px" size="mini" @change="need_save(scope.row)"></el-input-number>
            </template>
          </template>
        </template>
      </el-table-column>
      <el-table-column
          label="提交" width="70">
        <template slot-scope="scope">
          <el-button v-show="scope.row.need_save===true" icon="el-icon-check" size="mini" type="warning"
                     @click="save_row(scope.$index,scope.row)"></el-button>
        </template>
      </el-table-column>
      <el-table-column label="分配">
        <template slot-scope="scope">
          <template v-if="scope.row.mode==='s'||(scope.row.mode==='m'&&isNaN(parseFloat(scope.row.question_index)))">
            <el-button type="primary" size="mini" @click="set_teachers_question(scope.row)">分配
            </el-button>
            <el-button size="mini" @click="download_teacher_question(scope.row)">导出
            </el-button>
          </template>
        </template>
      </el-table-column>
    </el-table>
    <input type="file" ref="teacher_all_file" style="display:none" @change="on_teacher_all_change"/>
  </div>
</template>

<script>
  import XLSX from "xlsx";
  import FileSaver from "file-saver";
  import global_ from "../global";
  import TeacherSelectQuestion from "./TeacherSelectQuestion";
  import TeacherSelectExam from "./TeacherSelectExam";

  const admin_api = global_.admin_api;
  export default {
    name: "ReviewForm",
    components: {TeacherSelectQuestion,TeacherSelectExam},
    data() {
      return {
        select_teacher_question_show: false,
        select_teacher_exam_show: false,
        loading: false,
        set_row: {},
        current_question_group: [],
        mode_s: {
          's': '独立',
          'm': '合并'
        }
      }
    },
    props: ["review_table", "code"],
    methods: {
      index_method(v) {
        return v
      },
      set_scores(row) {
        let scores = row.scores.split(',')
        let out = []
        scores.forEach((v) => {
          let _ = parseFloat(v)
          if (!isNaN(_) && _ >= row.min_score && _ <= row.max_score) {
            out.push(_)
          }
        })
        out = Array.from(new Set(out))
        out = out.sort()
        if (out[0] !== row.min_score) {
          out.unshift(row.min_score)
        }
        if (out[out.length - 1] !== row.max_score) {
          out.push(row.max_score)
        }
        row.scores = out
        row.need_save = true
      },
      save_row(index, row) {
        row.need_save = false
        let request_data = {
          service_name: 'save_police',
          question: row
        }
        this.axios.post(admin_api, request_data).then(response => {
          let response_data = response.data
          this.$message({message: response_data['result_info'], duration: 1000, type: 'success'})
        })
      },
      set_teachers_template() {
        this.$confirm('此操作将覆盖已有的人员分配', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
        this.$refs.teacher_all_file.value = ""
        this.$refs.teacher_all_file.click()
        })
      },
      set_teachers_question(row) {
        this.set_row = row
        this.select_teacher_question_show = true
      },
      set_teachers_exam() {
        this.select_teacher_exam_show = true
      },
      on_teacher_all_change(e) {
        let file = e.target.files[0];
        let fileReader = new FileReader();
        fileReader.readAsBinaryString(file);
        fileReader.onload = e => {
          this.loading = true
          let data = e.target.result;
          let wb = XLSX.read(data, {
            type: "binary"
          });
          for (let index in wb.Sheets) {
            let sheet = wb.Sheets[index];
            let teachers = XLSX.utils.sheet_to_json(sheet, {
              range: 1,
              header: ['question_id', 'name', 'phone', 'is_super'],
              raw: false
            });
            for (let _ of teachers) {
              if (!/^1[3-9][0-9][\d]{8}$/.test(_.phone)) {
                this.$message({message: "数据中包含不合法的手机号", duration: 1000, type: 'warning'})
                return
              }
            }
            let request_data = {
              service_name: 'set_teachers_all',
              teachers: teachers,
              id: this.code
            }
            this.axios.post(admin_api, request_data).then(response => {
              let response_data = response.data
              this.loading = false
              this.$message({message: response_data['result_info'], duration: 1000, type: 'success'})
            })
            break
          }
        }
      },
      need_save(row) {
        row.need_save = true
      },
      download_teacher_question(row) {
        this.loading = true
        let request_data = {
          service_name: 'down_exam_teacher_question', id: row.question_id
        }
        fetch(admin_api, {
          method: 'POST', // or 'PUT'
          body: JSON.stringify(request_data), // data can be `string` or {object}!
          headers: new Headers({
            'Content-Type': 'application/json'
          })
        }).then(res => {
          this.loading = false
          if (res.ok) {
            res.blob().then(blob => FileSaver.saveAs(blob, "名册.xlsx"))
          } else {
            let d = [['姓名', '手机号', '组长']]
            let ws = XLSX.utils.aoa_to_sheet(d);
            let wb = XLSX.utils.book_new();
            let fn = "名册.xlsx";
            XLSX.utils.book_append_sheet(wb, ws);
            let wbout = XLSX.write(wb, {
              bookType: "xlsx",
              bookSST: true,
              type: "array"
            });
            FileSaver.saveAs(
              new Blob([wbout], {
                type:
                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
              }),
              fn
            );
          }
        })
      },
      download_teacher() {
        this.loading = true
        let request_data = {
          service_name: 'down_exam_teacher', id: this.code
        }
        fetch(admin_api, {
          method: 'POST', // or 'PUT'
          body: JSON.stringify(request_data), // data can be `string` or {object}!
          headers: new Headers({
            'Content-Type': 'application/json'
          })
        }).then(res => {
          this.loading = false
          if (res.ok) {
            res.blob().then(blob => FileSaver.saveAs(blob, "名册.xlsx"))
          } else {
            let d = [['题块号', '姓名', '手机号', '组长']]
            let ws = XLSX.utils.aoa_to_sheet(d);
            let wb = XLSX.utils.book_new();
            let fn = "名册.xlsx";
            XLSX.utils.book_append_sheet(wb, ws);
            let wbout = XLSX.write(wb, {
              bookType: "xlsx",
              bookSST: true,
              type: "array"
            });
            FileSaver.saveAs(
              new Blob([wbout], {
                type:
                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
              }),
              fn
            );
          }
        })
      },
      get_scores(row) {
        let s = row.min_score
        let e = row.max_score
        let step = row.score_step
        let step_v = (e - s) / (step - 1)
        let out = []
        if (step < 3) {
          out = [s, e]
        } else {
          for (let i = 0; i < step - 1; i++) {
            out.push(s + step_v * i)
          }
          out.push(e)
        }
        return out
      },
    }
  }
</script>

<style>
  .el-table__row.current-row {
    font-weight: bold;
    font-size: larger;
  }

</style>